import { MessageCircle, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const HeroSection = () => {
  const whatsappLink = "https://wa.me/5584988966860?text=Ol%C3%A1%20gostaria%20de%20atendimento";

  return (
    <section id="inicio" className="relative gradient-hero min-h-screen flex items-center overflow-hidden">
      {/* Decorative blobs */}
      <div className="blob-decoration w-[500px] h-[500px] -right-20 top-20" />
      <div className="blob-decoration w-[300px] h-[300px] right-1/4 bottom-10" />
      
      <div className="container mx-auto px-4 py-20">
        <div className="flex flex-col items-center text-center">
          {/* Left Content */}
          <div className="space-y-8 relative z-10">
            {/* Tag */}
            <div className="inline-flex items-center gap-2 bg-primary/90 text-primary-foreground px-4 py-2 rounded-full text-sm font-medium animate-fade-in">
              <span className="w-2 h-2 bg-white rounded-full animate-pulse" />
              Contabilidade Consultiva
            </div>

            {/* Headline */}
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-secondary-foreground leading-tight animate-fade-in" style={{ animationDelay: "0.1s" }}>
              Sua empresa pronta para{" "}
              <span className="text-gradient">avançar</span>{" "}
              com segurança.
            </h1>

            {/* Subtitle */}
            <p className="text-lg md:text-xl text-secondary-foreground/80 max-w-xl animate-fade-in" style={{ animationDelay: "0.2s" }}>
              Gestão contábil moderna para empreendedores que não têm medo de crescer.
            </p>

            {/* Buttons */}
            <div className="flex flex-wrap gap-4 justify-center animate-fade-in" style={{ animationDelay: "0.3s" }}>
              <Button variant="hero-primary" size="xl" asChild>
                <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
                  <MessageCircle className="h-5 w-5" />
                  Falar com um especialista
                </a>
              </Button>
              <Button variant="hero-secondary" size="xl" asChild>
                <a href="#solucoes">
                  Conhecer serviços
                  <ArrowRight className="h-5 w-5" />
                </a>
              </Button>
            </div>

            {/* Stats */}
            <div className="flex gap-8 pt-6 justify-center animate-fade-in" style={{ animationDelay: "0.4s" }}>
              <div>
                <p className="text-3xl font-heading font-bold text-secondary-foreground">+100</p>
                <p className="text-secondary-foreground/70 text-sm">Clientes atendidos</p>
              </div>
              <div>
                <p className="text-3xl font-heading font-bold text-secondary-foreground">+8</p>
                <p className="text-secondary-foreground/70 text-sm">Anos de experiência</p>
              </div>
              <div>
                <p className="text-3xl font-heading font-bold text-secondary-foreground">98%</p>
                <p className="text-secondary-foreground/70 text-sm">Clientes satisfeitos</p>
              </div>
            </div>
          </div>

          {/* Right Content - Image */}
          <div className="relative flex justify-center lg:justify-end animate-slide-up">
           
          </div>
        </div>
      </div>

      {/* Wave decoration at bottom */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 120L60 105C120 90 240 60 360 45C480 30 600 30 720 37.5C840 45 960 60 1080 67.5C1200 75 1320 75 1380 75L1440 75V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z"
            fill="white"
          />
        </svg>
      </div>
    </section>
  );
};

export default HeroSection;
